module.exports = __webpack_public_path__ + "img/logo.b4fbde3c.png";